import styled from "styled-components";
import { Button } from "semantic-ui-react";

export default styled(Button)`
  width: ${({ width }) => width ? width : '100%'};
  display: block;
  font-size: 1.3em;
  color: #ffffff;
  color: ${({ themed, color }) => color ? color : (themed ? '#fff !important' : '#fff !important')};
  padding: 0.5em 0;
  outline: none;
  border-radius: 3em;
  margin: 0.9em 0;
  cursor: pointer;
  background-color: ${({ themed, color }) => color ? color : (themed ? '#464481 !important' : '#ff9800 !important')}
;
`;